import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, AfterViewInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { KeycloakService } from 'keycloak-angular';
import { ConfirmationModalService } from 'src/app/services/confirmation-modal.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ResetAllStates } from 'src/app/state/reset.reducer';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() submessage: string = '';
  @Input() action: string = '';
  @ViewChild('modalTitle', { static: false }) modalTitle!: ElementRef;
  
  product: any;
  inApp: any;
  private focusableElements: HTMLElement[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private store: Store,
    private readonly keycloak: KeycloakService,
    private sessionStorage: SessionStorageService,
    private elementRef: ElementRef,
        private modalSvc: ConfirmationModalService,
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Focus the modal title for screen readers
    this.focusModalTitle();
    
    // Set up focus trap
    this.setupFocusTrap();
    
    // Set up keyboard event listener for modal
    this.setupModalKeyboardListener();
  }

  ngOnDestroy(): void {
    // Clean up any event listeners
    this.removeFocusTrap();
  }

  private focusModalTitle(): void {
    setTimeout(() => {
      const titleElement = this.elementRef.nativeElement.querySelector('#modal-basic-title');
      if (titleElement) {
        titleElement.focus();
      }
    }, 100);
  }

  private setupFocusTrap(): void {
    const modalElement = this.elementRef.nativeElement;
    this.focusableElements = Array.from(modalElement.querySelectorAll(
      'button, [tabindex]:not([tabindex="-1"])'
    ));
  }

  private removeFocusTrap(): void {
    this.focusableElements = [];
  }

  private setupModalKeyboardListener(): void {
    const modalElement = this.elementRef.nativeElement;
    modalElement.addEventListener('keydown', this.handleModalKeydown.bind(this));
  }

  private handleModalKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.dismissModal();
      return;
    }

    if (event.key === 'Tab') {
      this.trapFocus(event);
    }
  }

  private trapFocus(event: KeyboardEvent): void {
    if (this.focusableElements.length === 0) return;

    const firstFocusable = this.focusableElements[0];
    const lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    if (event.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  handleKeyNavigation(event: KeyboardEvent, action: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (action === 'close') {
        this.dismissModal();
      }
    }
  }

  private announceToScreenReader(message: string): void {
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    
    document.body.appendChild(announcement);
    
    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 1000);
  }

  timeout() {
     sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);

  }

  logout() {
    sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);
  }

  continueLater() {
      sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);
  }

  cancelApp() {
    sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);
  }

  continueAfterLegi() {
    this.activeModal.close();
    sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);
  }

  continueManualLegi() {
   sessionStorage.clear();
      localStorage.clear();
      this.store.dispatch(new ResetAllStates());
      this.keycloak.logout(window.location.origin);
  }

  dismissModal() {
    this.announceToScreenReader('Modal wurde geschlossen');
    this.activeModal.close();
  }

    delete() {
    this.activeModal.close();
    this.modalSvc.setPopupEvent('delete');
  }


  // logOutEbankingNavigate() {
  //   if (this.inApp && environment?.applyNative) {
  //     if (!this.closeWebView()) {
  //       return;
  //     }
  //   } else {
  //     this.store.dispatch(new ResetAllStates());
  //     this.keycloak.logout(window.location.origin);
  //     window.location.href = environment.ebankingUrl;
  //   }
  // }

  // private closeWebView() {
  //   const userApp = Helpers.checkOS();
  //   const message = {
  //     action: 'CLOSE_WEB_VIEW',
  //   };
  //   return Helpers.postMessage(JSON.stringify(message), userApp);
  // }
}
